export const mockClinicsList = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      id: 1, name: 'Default Clinic', subdomain: 'default',
      status: 'active', email: 'admin@default.com', phone: '9876543210',
      address: '123 Main St, City', created_at: '2025-01-01', owner_user_id: 1,
      logo_url: null, primary_color: '#7A6EFE', country: 'India',
    },
    {
      id: 2, name: 'Sunrise Therapy Center', subdomain: 'sunrise',
      status: 'active', email: 'admin@sunrise.com', phone: '9876543211',
      address: '456 Health Ave, Town', created_at: '2025-06-15', owner_user_id: 10,
      logo_url: null, primary_color: '#2CA538', country: 'India',
    },
    {
      id: 3, name: 'MindWell Clinic', subdomain: 'mindwell',
      status: 'trial', email: 'admin@mindwell.com', phone: '9876543212',
      address: '789 Wellness Rd, Village', created_at: '2026-01-01', owner_user_id: 20,
      logo_url: null, primary_color: '#FF6B6B', country: 'United States',
    },
    {
      id: 4, name: 'CareFirst Center', subdomain: 'carefirst',
      status: 'suspended', email: 'admin@carefirst.com', phone: '9876543213',
      address: '321 Care Blvd, Metro', created_at: '2025-09-10', owner_user_id: 30,
      logo_url: null, primary_color: '#7A6EFE', country: 'United Arab Emirates',
    },
  ],
};

export const mockClinicDetails = {
  rescode: 1,
  message: 'Success',
  data: {
    clinic: {
      id: 1, name: 'Default Clinic', subdomain: 'default',
      status: 'active', email: 'admin@default.com', phone: '9876543210',
      address: '123 Main St, City', logo_url: null, primary_color: '#7A6EFE',
    },
    stats: { users: 8, patients: 45, appointments: 312 },
    subscription: {
      id: 1, plan_id: 3, status: 'active', start_date: '2025-01-01',
      end_date: '2026-01-01', billing_cycle: 'yearly',
      plan: { name: 'Enterprise', price_monthly: 0, max_users: 99999, max_patients: 99999 },
    },
    payment_history: [
      {
        id: 1, clinic_id: 1, plan_id: 3, razorpay_order_id: 'order_MY8hA3lS2nRs9x',
        razorpay_payment_id: 'pay_MY8i4B3tLqUv0z', amount: 2499900,
        currency: 'INR', billing_cycle: 'yearly', status: 'paid',
        created_at: '2025-01-01T10:00:00Z',
        plan: { name: 'Enterprise', price_monthly: 0, price_yearly: 19999 },
      },
      {
        id: 2, clinic_id: 1, plan_id: 2, razorpay_order_id: 'order_LX7gZ2kR1mPq8v',
        razorpay_payment_id: 'pay_LX7h1B2aKpQr9w', amount: 1999900,
        currency: 'INR', billing_cycle: 'yearly', status: 'paid',
        created_at: '2024-12-01T14:15:00Z',
        plan: { name: 'Pro', price_monthly: 0, price_yearly: 14999 },
      },
      {
        id: 3, clinic_id: 1, plan_id: 2, razorpay_order_id: 'order_KW6fY1jQ0lOp7u',
        razorpay_payment_id: 'pay_KW6g0A1zJoPs8v', amount: 166600,
        currency: 'INR', billing_cycle: 'yearly', status: 'paid',
        created_at: '2024-11-01T09:30:00Z',
        plan: { name: 'Pro', price_monthly: 0, price_yearly: 14999 },
      },
    ],
    login_access: {
      summary: { total: 3, active: 3, inactive: 0, loggedIn: 2, neverLoggedIn: 1 },
      users: [
        { UserId: 101, FirstName: 'Anita', LastName: 'Sharma', Email: 'anita@default.com', Phone: '9876543210', RoleId: 2, RoleName: 'Admin', IsActive: 1, Image: null, designation: 'Clinic Admin', loginCount: 142, lastLoginAt: '2026-06-07T08:15:00Z' },
        { UserId: 102, FirstName: 'Rahul', LastName: 'Verma', Email: 'rahul@default.com', Phone: '9876500011', RoleId: 5, RoleName: 'Therapist', IsActive: 1, Image: null, designation: 'Physiotherapist', loginCount: 47, lastLoginAt: '2026-06-06T17:42:00Z' },
        { UserId: 103, FirstName: 'Sunil', LastName: 'Kumar', Email: 'sunil@default.com', Phone: '9876500033', RoleId: 5, RoleName: 'Receptionist', IsActive: 1, Image: null, designation: 'Front Desk', loginCount: 0, lastLoginAt: null },
      ],
    },
  },
};

export const mockPlansList = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      id: 1, name: 'Free Trial', max_users: 10, max_patients: 20, max_branches: 2,
      features: ['dashboard', 'patients', 'appointments', 'group_sessions', 'waiting_list', 'sessions', 'attendance', 'basic_billing', 'invoicing', 'income_expense', 'pricing_plans', 'billing_settlement', 'staff_management', 'salary_management', 'device_manager', 'predictive_intelligence', 'clinical_intelligence', 'data_export', 'support_tickets', 'multi_branch', 'cross_branch_analytics', 'white_label', 'branding'],
      price_monthly: 0, price_yearly: 0, price_monthly_usd: 0, price_yearly_usd: 0, is_active: 1,
    },
    {
      id: 2, name: 'Pro', max_users: 50, max_patients: 999, max_branches: 1,
      features: ['dashboard', 'patients', 'appointments', 'group_sessions', 'waiting_list', 'sessions', 'attendance', 'basic_billing', 'invoicing', 'income_expense', 'pricing_plans', 'billing_settlement', 'staff_management', 'salary_management', 'device_manager', 'predictive_intelligence', 'clinical_intelligence', 'data_export', 'support_tickets'],
      price_monthly: 1667, price_yearly: 19999, price_monthly_usd: 20, price_yearly_usd: 240, is_active: 1,
    },
    {
      id: 3, name: 'Enterprise', max_users: 999, max_patients: 999, max_branches: 2,
      features: ['dashboard', 'patients', 'appointments', 'group_sessions', 'waiting_list', 'sessions', 'attendance', 'basic_billing', 'invoicing', 'income_expense', 'pricing_plans', 'billing_settlement', 'staff_management', 'salary_management', 'device_manager', 'predictive_intelligence', 'clinical_intelligence', 'data_export', 'support_tickets', 'multi_branch', 'cross_branch_analytics', 'white_label', 'branding'],
      price_monthly: 2083, price_yearly: 24999, price_monthly_usd: 25, price_yearly_usd: 300, is_active: 1,
    },
  ],
};

export const mockSubscriptionsList = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      id: 1, clinic_id: 1, plan_id: 3, status: 'active', start_date: '2025-01-01',
      end_date: '2026-01-01', billing_cycle: 'yearly',
      plan: { name: 'Enterprise', price_monthly: 0 },
      clinic: { name: 'Default Clinic' },
    },
    {
      id: 2, clinic_id: 2, plan_id: 2, status: 'active', start_date: '2025-06-15',
      end_date: '2026-06-15', billing_cycle: 'yearly',
      plan: { name: 'Pro', price_monthly: 0 },
      clinic: { name: 'Sunrise Therapy Center' },
    },
    {
      id: 3, clinic_id: 3, plan_id: 1, status: 'trial', start_date: '2026-03-08',
      end_date: '2026-03-15', billing_cycle: 'yearly',
      plan: { name: 'Free Trial', price_monthly: 0 },
      clinic: { name: 'MindWell Clinic' },
    },
    {
      id: 4, clinic_id: 4, plan_id: 1, status: 'expired', start_date: '2025-09-10',
      end_date: '2025-09-17', billing_cycle: 'yearly',
      plan: { name: 'Free Trial', price_monthly: 0 },
      clinic: { name: 'CareFirst Center' },
    },
  ],
};

export const mockSaasAnalytics = {
  rescode: 1,
  message: 'Success',
  data: {
    total_clinics: 4,
    active_subscriptions: 2,
    trial_subscriptions: 1,
    expired_subscriptions: 1,
    mrr: 6581.50,
    arr: 78978.00,
    churn_rate: 3.2,
    clinics_by_country: [
      { country: 'India', count: 12 },
      { country: 'United States', count: 5 },
      { country: 'United Arab Emirates', count: 3 },
      { country: 'United Kingdom', count: 2 },
      { country: 'Canada', count: 1 },
      { country: 'Australia', count: 1 },
    ],
    monthly_revenue: [
      { month: '2025-07', revenue: 4200, new_clinics: 1 },
      { month: '2025-08', revenue: 4800, new_clinics: 0 },
      { month: '2025-09', revenue: 5100, new_clinics: 1 },
      { month: '2025-10', revenue: 5400, new_clinics: 0 },
      { month: '2025-11', revenue: 5900, new_clinics: 1 },
      { month: '2025-12', revenue: 6200, new_clinics: 0 },
      { month: '2026-01', revenue: 6581, new_clinics: 1 },
      { month: '2026-02', revenue: 6800, new_clinics: 0 },
    ],
  },
};

export const mockOnboardingStatus = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      clinic_id: 3, clinic_name: 'MindWell Clinic', created_at: '2026-01-01',
      steps: {
        profile_complete: true,
        logo_uploaded: false,
        staff_added: true,
        patients_added: false,
        first_appointment: false,
        payment_setup: false,
      },
    },
    {
      clinic_id: 2, clinic_name: 'Sunrise Therapy Center', created_at: '2025-06-15',
      steps: {
        profile_complete: true,
        logo_uploaded: true,
        staff_added: true,
        patients_added: true,
        first_appointment: true,
        payment_setup: false,
      },
    },
    {
      clinic_id: 4, clinic_name: 'CareFirst Center', created_at: '2025-09-10',
      steps: {
        profile_complete: true,
        logo_uploaded: false,
        staff_added: false,
        patients_added: false,
        first_appointment: false,
        payment_setup: false,
      },
    },
  ],
};

export const mockCrossBranchComparison = {
  rescode: 1,
  message: 'Success',
  data: [
    { clinic_id: 1, name: 'Default Clinic', revenue: 285000, patients: 45, appointments: 312, completion_rate: 87 },
    { clinic_id: 2, name: 'Sunrise Therapy Center', revenue: 192000, patients: 32, appointments: 198, completion_rate: 91 },
  ],
};

export const mockCrossBranchRevenue = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      clinic_id: 1, clinic_name: 'Default Clinic', monthly_revenue: [
        { month: '2025-07', revenue: 42000 },
        { month: '2025-08', revenue: 45000 },
        { month: '2025-09', revenue: 48000 },
        { month: '2025-10', revenue: 47000 },
        { month: '2025-11', revenue: 51000 },
        { month: '2025-12', revenue: 52000 },
      ],
    },
    {
      clinic_id: 2, clinic_name: 'Sunrise Therapy Center', monthly_revenue: [
        { month: '2025-07', revenue: 28000 },
        { month: '2025-08', revenue: 31000 },
        { month: '2025-09', revenue: 33000 },
        { month: '2025-10', revenue: 32000 },
        { month: '2025-11', revenue: 35000 },
        { month: '2025-12', revenue: 33000 },
      ],
    },
  ],
};

export const mockCrossBranchPerformance = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      clinic_id: 1, clinic_name: 'Default Clinic', therapist_count: 2, therapists: [
        { therapist_id: 5, therapist_name: 'Dr. Sharma', total_appointments: 120, completed_appointments: 108, completion_rate: 90 },
        { therapist_id: 6, therapist_name: 'Dr. Patel', total_appointments: 95, completed_appointments: 82, completion_rate: 86 },
      ],
    },
    {
      clinic_id: 2, clinic_name: 'Sunrise Therapy Center', therapist_count: 2, therapists: [
        { therapist_id: 7, therapist_name: 'Dr. Singh', total_appointments: 100, completed_appointments: 94, completion_rate: 94 },
        { therapist_id: 8, therapist_name: 'Dr. Gupta', total_appointments: 80, completed_appointments: 70, completion_rate: 88 },
      ],
    },
  ],
};

// ─── Activity Logs ──────────────────────────────────────────────────────────
export const mockActivityLogs = {
  rescode: 1,
  message: 'Success',
  data: [
    { id: 1, action: 'clinic_created', actor: 'Super Admin', target: 'MindWell Clinic', details: 'New clinic registered', created_at: '2026-02-27T10:30:00Z' },
    { id: 2, action: 'subscription_assigned', actor: 'Super Admin', target: 'Sunrise Therapy Center', details: 'Pro plan assigned (yearly)', created_at: '2026-02-26T14:15:00Z' },
    { id: 3, action: 'clinic_suspended', actor: 'Super Admin', target: 'CareFirst Center', details: 'Clinic suspended due to non-payment', created_at: '2026-02-25T09:00:00Z' },
    { id: 4, action: 'plan_updated', actor: 'Super Admin', target: 'Pro Plan', details: 'Price updated to ₹19,999/yr', created_at: '2026-02-24T16:45:00Z' },
    { id: 5, action: 'impersonation', actor: 'Super Admin', target: 'Default Clinic', details: 'Admin impersonated clinic', created_at: '2026-02-24T11:20:00Z' },
    { id: 6, action: 'clinic_activated', actor: 'Super Admin', target: 'CareFirst Center', details: 'Clinic reactivated', created_at: '2026-02-23T08:30:00Z' },
    { id: 7, action: 'subscription_expired', actor: 'System', target: 'CareFirst Center', details: 'Free Trial expired', created_at: '2026-02-22T00:00:00Z' },
    { id: 8, action: 'branding_updated', actor: 'Sunrise Admin', target: 'Sunrise Therapy Center', details: 'Logo and primary color updated', created_at: '2026-02-21T13:10:00Z' },
    { id: 9, action: 'payment_received', actor: 'System', target: 'Default Clinic', details: 'Payment of ₹24,999 received for Enterprise yearly', created_at: '2026-02-20T10:00:00Z' },
    { id: 10, action: 'clinic_created', actor: 'Super Admin', target: 'HealthFirst Clinic', details: 'New clinic onboarded with Free Trial', created_at: '2026-02-19T15:30:00Z' },
  ],
};

// ─── Usage Stats ────────────────────────────────────────────────────────────
export const mockUsageStats = {
  rescode: 1,
  message: 'Success',
  data: {
    platform_totals: {
      total_users: 46,
      total_patients: 122,
      total_appointments: 587,
      total_sessions: 412,
      active_today: 12,
    },
    clinic_usage: [
      { clinic_id: 1, clinic_name: 'Default Clinic', users: 8, patients: 45, appointments: 312, storage_mb: 256, api_calls_today: 1240, last_active: '2026-02-27T10:30:00Z' },
      { clinic_id: 2, clinic_name: 'Sunrise Therapy Center', users: 6, patients: 32, appointments: 198, storage_mb: 180, api_calls_today: 890, last_active: '2026-02-27T09:15:00Z' },
      { clinic_id: 3, clinic_name: 'MindWell Clinic', users: 3, patients: 15, appointments: 47, storage_mb: 45, api_calls_today: 320, last_active: '2026-02-27T08:00:00Z' },
      { clinic_id: 4, clinic_name: 'CareFirst Center', users: 5, patients: 30, appointments: 30, storage_mb: 120, api_calls_today: 0, last_active: '2026-02-20T14:00:00Z' },
    ],
    daily_active_users: [
      { date: '2026-02-21', count: 8 },
      { date: '2026-02-22', count: 10 },
      { date: '2026-02-23', count: 7 },
      { date: '2026-02-24', count: 12 },
      { date: '2026-02-25', count: 11 },
      { date: '2026-02-26', count: 14 },
      { date: '2026-02-27', count: 12 },
    ],
  },
};

// ─── Payment Failures ───────────────────────────────────────────────────────
export const mockPaymentFailures = {
  rescode: 1,
  message: 'Success',
  data: [
    {
      id: 1, clinic_id: 4, clinic_name: 'CareFirst Center', amount: 166600, currency: 'INR',
      plan_name: 'Pro', billing_cycle: 'yearly', error_code: 'BAD_REQUEST_ERROR',
      error_description: 'Payment processing failed due to insufficient funds',
      razorpay_order_id: 'order_FAIL_001', attempts: 3,
      first_failed_at: '2026-02-20T10:00:00Z', last_failed_at: '2026-02-25T10:00:00Z',
      status: 'unresolved',
    },
    {
      id: 2, clinic_id: 3, clinic_name: 'MindWell Clinic', amount: 1999900, currency: 'INR',
      plan_name: 'Pro', billing_cycle: 'yearly', error_code: 'GATEWAY_ERROR',
      error_description: 'Payment gateway timeout',
      razorpay_order_id: 'order_FAIL_002', attempts: 1,
      first_failed_at: '2026-02-26T14:30:00Z', last_failed_at: '2026-02-26T14:30:00Z',
      status: 'unresolved',
    },
    {
      id: 3, clinic_id: 1, clinic_name: 'Default Clinic', amount: 2499900, currency: 'INR',
      plan_name: 'Enterprise', billing_cycle: 'yearly', error_code: 'BAD_REQUEST_ERROR',
      error_description: 'Card declined by issuing bank',
      razorpay_order_id: 'order_FAIL_003', attempts: 2,
      first_failed_at: '2026-02-15T09:00:00Z', last_failed_at: '2026-02-18T09:00:00Z',
      status: 'resolved',
    },
  ],
};

// ─── Payment Gateway (Phase 6) ─────────────────────────────────────────────

export const mockPaymentCreateOrder = {
  rescode: 1,
  message: 'Order created',
  data: {
    order_id: 'order_mock_123456789',
    amount: 99900,
    currency: 'INR',
    key_id: 'rzp_test_mock',
    plan_name: 'Pro',
  },
};

export const mockPaymentVerify = {
  rescode: 1,
  message: 'Payment verified and subscription activated',
  data: {
    subscription: {
      id: 5, clinic_id: 1, plan_id: 2, status: 'active',
      start_date: '2026-02-27', end_date: '2026-03-27',
      billing_cycle: 'yearly', razorpay_payment_id: 'pay_mock_987654321',
    },
    payment_order: {
      id: 1, razorpay_order_id: 'order_mock_123456789',
      razorpay_payment_id: 'pay_mock_987654321', status: 'paid',
      amount: 99900, currency: 'INR',
    },
  },
};

export const mockImpersonateClinic = {
  rescode: 1,
  message: 'Success',
  data: {
    userData: {
      uid: 10, UserName: 'admin@sunrise.com', Email: 'admin@sunrise.com',
      FirstName: 'Sunrise', LastName: 'Admin', Image: null,
      RoleId: 2, RoleName: 'Admin', clinic_id: 2,
    },
    token: 'mock-impersonation-jwt-token',
    refreshToken: 'mock-impersonation-refresh-token',
    modules: [],
    permissions: ['view_patients', 'view_employees', 'view_appointments', 'view_income_expense', 'view_finance', 'view_analytics'],
    clinic: { id: 2, name: 'Sunrise Therapy Center', subdomain: 'sunrise' },
  },
};

export const mockPaymentHistory = {
  rescode: 1,
  message: 'Success',
  data: {
    current_subscription: {
      plan_id: 2, plan_name: 'Pro', status: 'active',
      start_date: '2025-06-15', end_date: '2026-06-15',
    },
    payments: [
      {
        id: 1, clinic_id: 1, plan_id: 2, razorpay_order_id: 'order_LX7gZ2kR1mPq8v',
        razorpay_payment_id: 'pay_LX7h1B2aKpQr9w', amount: 1499900,
        currency: 'INR', billing_cycle: 'yearly', status: 'paid',
        created_at: '2025-06-15T10:30:00Z',
        plan: { name: 'Pro', price_yearly: 14999 },
      },
    ],
  },
};
